import React from 'react';
import Link from 'next/link';
import { ShoppingCarIcon } from '@avila-tek/ui/src';
import { IRoute } from '../../routes';
import { Breadcrumb, Sidebar, UserPhoto } from '../navigation';
import { useUser } from '../../hooks';
import { roles } from '../../static';
import { ChangePasswordModal } from '../shared';

interface LayoutProps {
  children: React.ReactNode;
  sectionTitle: string;
  routesHistory: Partial<IRoute>[];
}
function Layout({ children, routesHistory, sectionTitle }: LayoutProps) {
  const [user] = useUser();
  // if its the first login, show the change password modal
  const [changePasswordModalIsOpen, setChangePasswordModalIsOpen] =
    React.useState(!user?.firstLogin);

  return (
    <main className="min-h-screen pb-10 w-full relative">
      <Sidebar />
      <nav className=" w-full flex relative">
        {user?.userType === roles.company ? (
          <Link href="/app/shopcart">
            <ShoppingCarIcon className="w-6 h-6 text-white sm:text-neutral-400 absolute right-11 md:right-20 top-8 md:top-6 z-50 cursor-pointer" />
          </Link>
        ) : null}
        <UserPhoto className="hidden md:block ml-auto m-5 h-12 w-12" />
      </nav>
      <div className="w-full max-w-[1440px] mx-auto md:pl-[17.5rem]">
        <section className="relative pt-10 md:pt-16  px-10  ">
          <div className="mb-5">
            <Breadcrumb routesHistory={routesHistory} />
          </div>
          <h2 className="text-xl  md:text-2xl text-neutral-700 font-semibold ">
            {sectionTitle}
          </h2>
        </section>
        <section className="mt-10 relative w-full px-10">{children}</section>
      </div>
      <ChangePasswordModal
        isOpen={changePasswordModalIsOpen}
        setOpen={setChangePasswordModalIsOpen}
        firstLogin
      />
    </main>
  );
}

export default Layout;
